import { gql } from "graphql-tag";

/**
 *
 * Gets booking ussing uuid
 * Here is a variable example
 * { "uuid": "(uuid,eq,4XcKXvRoAx)" }
 */
export const GET_BookingWithUUID = gql`
  query GETBookingWithUUID($uuid: String!) {
    booking: ProductSlotBookingList(where: $uuid) {
      id: Id
      uid: Uuid
      token: GoerToken
      invoiceId: InvoiceId
      GroupRead {
        groupUuid: Uuid
      }
    }
  }
`;

// {
//   "Id": 30588,
//     "Uuid": "4XcKXvRoAx"
// },
// {
//   "Id": 30587,
//     "Uuid": "ObpkctA3BV"
// },
// {
//   "Id": 30586,
//     "Uuid": "d46dldJaVm"
// },

/**
 *
 * Gets booking using its Id
 * Here is a variable example
 * { "Id": "(id,eq,1234)" }
 */
export const GET_FullBookingById = gql`
  query GetFullBookingById($id: String!) {
    booking: ProductSlotBookingList(where: $id) {
      id: Id
      #When Uuid is null, we are assigning Id value to it
      uuid: Uuid
      reference: Reference
      state: State
      languageId: LanguageId
      sellerId: SellerId
      userId: UserId
      customerId: CustomerId
      email: Email
      firstName: FirstName
      lastName: LastName
      currency: Currency
      insertDateTime: InsertDateTime
      updatedAt: UpdatedAt
      message: Message
      type: Type
      #Missing CashfloatUuid: This booking will be linked to the current cashfloat only if user does CASH payment/refund

      customFieldsAnswers: BookingFieldAnswerList {
        answer: Answer
        bookingUuid: BookingId
        createdAt: CreatedAt
        CustomBookingFieldId
        customField: CustomBookingFieldRead {
          answerExample: AnswerExample
          cancelled: Canceled
          #customFieldType
          id: Id
          informationType: InformationType
          list: List
          name: Name
          position: Position
          productId: ProductId
          questionType: QuestionType
          validation: Validation
          visibleFor: VisibleFor
        }
        #listAnswer
        updatedAt: UpdatedAt
        uuid: Id
        id: Id
      }

      pssList: ProductSlotStateList {
        id: Id
        uuid: Uuid
        token: Token
        bookingId: BookingId
        #Missing BookingUuid, it is manageable --> We assigned booking.Uuid value mentioned above to it
        paymentStatus: PaymentStatus
        bookingStatus: BookingStatus
        scanningStatus: ScanningStatus
        scanningUserId: ScanningUserId
        seat: Seat
        fullSeat: FullSeat
        creationDateTime: CreationDateTime
        canceledAt: CanceledAt
        refundedAt: RefundedAt
        updatedAt: UpdatedAt
        email: Email
        startDateTime: StartDateTime
        endDateTime: EndDateTime
        timeslot: TimeSlotRead {
          eventKey: EventKey
        }
        priceValue: PriceValue
        accountingValue: AccountingValue
        priceId: PriceId
        priceName: PriceName
        ProductSlotPriceRead {
          RetailOptionList {
            Id
            OptionName
            OptionType
          }
        }
        paymentFeeCollected: PaymentFeeCollected
        paymentFeeEffective: PaymentFeeEffective
        paymentFeeBilled: PaymentFeeBilled
        refundAmount: RefundAmount
        barCode: BarCode
        categoryId: CategoryId
        categoryName: CategoryName
        ProductSlotCategoryRead {
          ProductId
          Id
          Type
          TicketGroupTicketList {
            TicketGroupId
          }

          # mainCategory used to check if the ticket is of type seating membership.
          mainCategory: ProductSlotCategoryRead {
            id: Id
            type: Type
          }

          productRead: ProductRead {
            customTicketFieldList: CustomTicketFieldList {
              answerExample: AnswerExample
              cancelled: Canceled
              #customFieldType
              id: Id
              informationType: InformationType
              list: List
              name: Name
              position: Position
              productId: ProductId
              questionType: QuestionType
              validation: Validation
              visibleFor: VisibleFor
              prices: ProductSlotPriceMMList {
                id: Id
              }
            }
            customBookingFieldList: CustomBookingFieldList {
              answerExample: AnswerExample
              cancelled: Canceled
              #customFieldType
              id: Id
              informationType: InformationType
              list: List
              name: Name
              position: Position
              productId: ProductId
              questionType: QuestionType
              validation: Validation
              visibleFor: VisibleFor
            }
          }
        }
        #productId: Getting it from above, ProductSlotCategoryRead
        type: Type
        promocodeDiscountValue: PromocodeDiscountValue
        timeSlotId: TimeSlotId
        sellerUserId: SellerUserId
        productOwnerGroupId: ProductOwnerGroupId
        _discountValue: DiscountValue
        sendTicket: SendTicket
        mainTicketId: MainTicketId
        mainTicketUUID: MainTicketUuid
        mainSlot: MainSlot
        packagePriceId: PackagePriceId
        PackagePriceRead {
          Id
          PriceId
          AutomaticallyBook
        }
        customFieldsAnswers: TicketFieldAnswerList {
          answer: Answer
          #pssUuid: BookingId
          createdAt: CreatedAt
          CustomTicketFieldId
          customField: CustomTicketFieldRead {
            answerExample: AnswerExample
            cancelled: Canceled
            #customFieldType
            id: Id
            informationType: InformationType
            list: List
            name: Name
            position: Position
            productId: ProductId
            questionType: QuestionType
            validation: Validation
            visibleFor: VisibleFor
          }
          #listAnswer
          updatedAt: UpdatedAt
          uuid: Id
          id: Id
        }

        OrderSessionRead {
          Id
          Uid
        }
      }
      accountings: AccountingList {
        _id: Id
        id: Id
        uuid: Uuid
        bookingId: BookingId
        originalAccountingId: OriginalAccountingId # This will have a value if the current accounting is a refund of another accounting
        #Missing bookingUuid  --> We assigned booking.Uuid value mentioned above to it
        promoCodeId: PromoCodeId
        #Missing promoCodeUuid: Do we really need to un-apply a promocode? I think obviously No
        value: Value
        paymentCurrency: PaymentCurrency
        #paymentCurrencyValue: PaymentCurrencyValue
        providedCashBill: ProvidedCashBill
        exchangeRate: ExchangeRate
        state: State
        transactionType: TransactionType
        paymentMethod: PaymentMethod
        createdAt: CreatedAt
        message: Message
        note: Note
        isDeposit: IsDeposit
        updatedAt: UpdatedAt
        currency: Currency
        discountId: DiscountId
        #Missing: discountUuid: Do we really need to edit an applied discount value? I think obviously No
        pspReference: PspReference
        refundPspReference: RefundPspReference
        #Missing posPaymentMethod: This is special for new POS bookings, if the user when editing is going to pay a ticket then we will use it when creating a new accounting only
        cashRegisterId: CashRegisterId
        ## Below are split info: For the missing ones, if we don't pull them and we don't split them are they going to be updated in the backend
        #Missing transactionTimestamp
        #Missing saleId
        #Missing poiId
        #Missing accountCode
        #Missing fullTransactionId
        #Missing paymentDetails
        transactionId: TransactionId
        splitReference: SplitReference
        refund: Refund
        CfUid: CfUid
        channel: Channel
        OrderSessionRead {
          Id
          Uid
        }

        PromoCodeRead {
          code: Code
        }

        accountingEntriesList: AccountingEntryList {
          _id: Id
          id: Id
          uuid: Uuid
          accountingId: AccountingId
          #Missing but you can get it accountingUuid --> This is assigned a value when we convert the pulled order into an IPSB format
          #Missing productSlotStateUuid --> This is assigned a value when we convert the pulled order into an IPSB format
          productSlotStateId: ProductSlotStateId
          ProductSlotStateRead {
            Id
            Uuid
          }
          value: Value
          paymentCurrencyValue: PaymentCurrencyValue
          groupId: GroupId
          bookingStatementVersion: BookingStatementVersion
          createdAt: CreatedAt
          updatedAt: UpdatedAt
          productId: ProductId
          acompteConfigId: AcompteConfigId

          # For TAX AE
          taxId: TaxId

          # new TAX logic
          salesTaxIncluded: SalesTaxIncluded
          salesTaxRate: SalesTaxRate
          salesTaxMicroValue: SalesTaxMicroValue

          OrderSessionRead {
            Id
            Uid
          }

          OfferRead {
            Id
            Uid
          }
        }
      }

      CustomerRead {
        id: Id
        email: Email
        firstName: FirstName
        lastName: LastName
        city: City
        address: Address
        phone: Phone
        zipCode: ZipCode
        allergies: Allergies
        language: LanguageRead {
          id: Id
          name: Name
          code: Code
          nativeName: NativeName
          local: Local
        }
        birthDate: BirthDate
        title: Title
        emailMarketingOrganiser: EmailMarketingOrganiser
        company: Company
        country: CountryRead {
          id: Id
          name: Name
        }
      }

      orderSessions: OrderSessionList {
        Id
        Uid
        State
        CreatedAt
        UpdatedAt
        CompletionDate
        Channel
        seqNumber: SeqNumber
        receiptCounter: Reference
      }

      GroupRead {
        groupUuid: Uuid
      }
    }
  }
`;

/**
 *
 * Gets booking accountings using its Id
 * Here is a variable example
 * { "bookingId": "(bookingId,eq,1234)" }
 */
export const GET_BookingAccountings = gql`
  query GetBookingAccountings($bookingId: String!) {
    accountings: AccountingList(where: $bookingId) {
      _id: Id
      id: Id
      uuid: Uuid
      bookingId: BookingId
      #Missing bookingUuid  --> We assigned booking.Uuid value mentioned above to it
      promoCodeId: PromoCodeId
      #Missing promoCodeUuid: Do we really need to un-apply a promocode? I think obviously No
      value: Value
      paymentCurrency: PaymentCurrency
      #paymentCurrencyValue: PaymentCurrencyValue
      providedCashBill: ProvidedCashBill
      exchangeRate: ExchangeRate
      state: State
      transactionType: TransactionType
      paymentMethod: PaymentMethod
      createdAt: CreatedAt
      message: Message
      isDeposit: IsDeposit
      updatedAt: UpdatedAt
      currency: Currency
      discountId: DiscountId
      #Missing: discountUuid: Do we really need to edit an applied discount value? I think obviously No
      pspReference: PspReference
      refundPspReference: RefundPspReference
      #Missing posPaymentMethod: This is special for new POS bookings, if the user when editing is going to pay a ticket then we will use it when creating a new accounting only
      cashRegisterId: CashRegisterId
      ## Below are split info: For the missing ones, if we don't pull them and we don't split them are they going to be updated in the backend
      #Missing transactionTimestamp
      #Missing saleId
      #Missing poiId
      #Missing accountCode
      #Missing fullTransactionId
      #Missing paymentDetails
      transactionId: TransactionId
      splitReference: SplitReference
      refund: Refund
      CfUid: CfUid

      PromoCodeRead {
        code: Code
        __typename
      }

      accountingEntriesList: AccountingEntryList {
        _id: Id
        id: Id
        uuid: Uuid
        accountingId: AccountingId
        #Missing but you can get it accountingUuid --> This is assigned a value when we convert the pulled order into an IPSB format
        #Missing productSlotStateUuid --> This is assigned a value when we convert the pulled order into an IPSB format
        productSlotStateId: ProductSlotStateId
        ProductSlotStateRead {
          Id
          Uuid
          __typename
        }
        value: Value
        paymentCurrencyValue: PaymentCurrencyValue
        groupId: GroupId
        bookingStatementVersion: BookingStatementVersion
        createdAt: CreatedAt
        updatedAt: UpdatedAt
        productId: ProductId
        acompteConfigId: AcompteConfigId

        # For TAX AE
        taxId: TaxId

        # new TAX logic
        salesTaxIncluded: SalesTaxIncluded
        salesTaxRate: SalesTaxRate
        salesTaxMicroValue: SalesTaxMicroValue

        OfferRead {
          Id
          Uid
          __typename
        }
        __typename
      }
      group: GroupRead {
        groupUuid: Uuid
        __typename
      }
      __typename
    }
  }
`;

/**
 *
 * Gets accounting ussing uuid
 * Here is a variable example
 * { "uuid": "(uuid,eq,4XcKXvRoAx)" }
 */
export const GET_AccountingWithUUID = gql`
  query GETAccountingWithUUID($uuid: String!) {
    accounting: AccountingList(where: $uuid) {
      id: Id
      uid: Uuid
      state: State
      ProductSlotBookingRead {
        GroupRead {
          groupUuid: Uuid
        }
      }
    }
  }
`;
